import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex } from 'rebass'
import { Grid } from '../../utils/style'

// import typography from '../../utils/typography'

const Wrapper = styled(Flex)`
  position: relative;
  z-index: 2;
  background: white;
  overflow-y: clip;
`

const RouterItem = styled(Grid)`
  background-color: ${(props) => props.theme.colors.blue_light};
  text-align: center;
  flex-grow: 1;
  flex-basis: 25%;

  a {
    flex-grow: 1;
    text-decoration: none;
    text-transform: uppercase;
    font-size: ${rem('14.5px')};
    font-weight: 600;
    letter-spacing: 0.12em;
    color: ${(props) => props.theme.colors.grey_op75};
    display: block;
    padding: 9px 11px 9px 12px;
    transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
    background-color: ${(props) => props.theme.colors.blue_light};
    mix-blend-mode: multiply;
  }

  &:hover a {
    opacity: 1;
    color: ${(props) => props.theme.colors.grey_op80};
  }

  a.active {
    position: relative;
    z-index: 1;
    color: ${(props) => props.theme.colors.blue};
    background-color: ${(props) => props.theme.colors.blue_light};
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.15);
    mix-blend-mode: initial;
    opacity: 1;
  }
`

class RouterSecondaryExpanded extends React.PureComponent {
  render() {
    const subSections = this.props.sections
    return (
      <Wrapper id="target-secondary">
        {subSections.map((subSection) => (
          <RouterItem key={`subsection:${subSection.slug}`} ml="auto">
            <Link
              to={subSection.slug}
              getProps={({ isPartiallyCurrent }) =>
                isPartiallyCurrent ||
                (this.props.highlightNew && subSection.label === 'New')
                  ? { className: 'active' }
                  : null
              }
            >
              {subSection.label}
            </Link>
          </RouterItem>
        ))}
      </Wrapper>
    )
  }
}

export default RouterSecondaryExpanded
